import React,{useEffect} from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';
import { VariableTransactions } from './VariableTransactions';

function EditTransaction({ arr,open, setOpen }) {
    let { mode, dispatch,langLocal } = AbstructVar()
    const { translate } = AbstructLang()
    const { state, setStateCustom, setLoad,setState } = VariableTransactions()
    useEffect(()=>{
        setState((prevState) => ({
            ...prevState,
            account_id: arr.account?.id,
            account_name: arr.account?.name,
            amount: arr.amount,
            description: arr?.description
        }));
    },[])
    const Submit = e => {
        e.preventDefault()
        console.log(state)
        //dispatch(putUser(arr.id,state.name,state.email,state.password,state.role, setLoad))
    }
    const formFields = [
        {
            name: "account", label: "account", type: "text", inputType: 'one_select', iconType: "user",
            options: [{value: 1,label: 'account 1'},{value: 2,label: 'account 2'}],
            defaultvaluee: {value: state.account_id , label: state.account_name }
        },
        { name: 'amount', label: 'amount', type: 'number', inputType: 'text', iconType: "pencil" },
        { name: "description", label: "description", type: "text", inputType: 'text', iconType: "pencil" },
    ];
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupR`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
                <div className={`div_title_popup ${mode === 'dark' ? "darktoppopup":"lighttoppopup"}`}  >
                    <p className={`title_popup ${mode === 'dark' ? "darktext" : "lighttext"}`} >{translate('edit_account')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={Submit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
            </div>
        </RModal>
    )
}

export default EditTransaction

